import { createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { ProductVaiantDetail, TECProductVairantModal } from "@tecumseh/Services/TECProdunctVairant";
import { CustomApiHandler } from "@tecumseh/Store/CustomHandlerCreator/CustomHandlerCreator";

export interface Parameter {
    productIds?: string;
    variantTypeId?: string;
    pageSize?: number;
    expand?: string[];
}

type HandlerType = CustomApiHandler<Parameter, TECProductVairantModal>;

export const DispatchBeginProductVairant: HandlerType = props => {
    props.dispatch({
        type: "Custom/ProductDetails/BeginProductVairant",
    });
};

export const PopulateApiParameter: HandlerType = props => {
    const {...parameter } = props.parameter;
    const convertString = parameter?.productIds;

    props.apiParameter = {
        productIds: `${convertString}/variantchildren?`,
        pageSize: 500,
        expand: ["content", "documents", "specifications", "attributes"],
    };
};

export const RequestDataFromApi: HandlerType = async props => {
    props.apiResult = await ProductVaiantDetail(props.apiParameter);
};

export const ProductVaiantCompleted: HandlerType = props => {
    if (!props.apiResult) {
        return;
    }
    props.dispatch({
        type: "Custom/ProductDetails/CompltedProductVairant",
        result: props.apiResult,
    });

    const { ...parameter } = props.parameter;
    const parentProductId = parameter?.productIds;

    props.dispatch({
        type: "Custom/ProductDetails/UpdateParentProductId",
        parentProductId,
    });
};

export const chain = [DispatchBeginProductVairant, PopulateApiParameter, RequestDataFromApi, ProductVaiantCompleted];

const tecProductSpecification = createHandlerChainRunner(chain, "CenLoadCarouselProductsWithIds");
export default tecProductSpecification;
